module.exports = __webpack_public_path__ + "img/support.7a90bf4.svg";